import Button from "@/app/components/common/Button";
import eventBus from "@/app/eventBus";
import { useMapView } from "@/app/hooks/useMapView";
import { PS_EVENTS } from "@/app/ps-events";
import { useTranslations } from "next-intl";
import { useCallback } from "react";
export const ViewOnMap = () => {
	const t = useTranslations('Keywords');
	const { isListView, setListView, isFullScreenMap } = useMapView();
	const handleClickViewOnMap = useCallback(() => {
		eventBus.publish(PS_EVENTS.LIST_VIEW, false)
		setListView(false)
	}, [])

	if (!isListView || isFullScreenMap) {
		return null
	}

	return (
		<div className="hidden xl:flex filters-view-on-map-container">
			<Button
				name="view-on-map"
				bgColor="white"
				fontSize="sm"
				font="bold"
				className="filters-view-on-map-button"
				onClick={handleClickViewOnMap}
			>
				{t('viewOnMap')}
			</Button>
		</div>

	)
}